import { BrowserRouter, Routes, Route } from "react-router-dom";
import App from "./App";
import EntreprisePage from "./pages/EntreprisePage";

export default function AppRouter() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/entreprise" element={<EntreprisePage />} />
      </Routes>
    </BrowserRouter>
  );
}
